import { EnvironmentNames } from "@origin-digital/platform-enums";
import { logger } from "@origin-digital/reporting-client";
import { IAuth0Config } from "../interfaces/index";
import { LOG_TAG } from "../logTag";
import { auth0ConfigTest } from "./test";
import { auth0ConfigStaging } from "./staging";
import { auth0ConfigProd } from "./prod";
import { auth0BrandConfigs, getBrand, ORIGIN_BRAND } from "./brands";

export type Auth0EnvConfigs = {
  [key in EnvironmentNames]: IAuth0Config;
};

export const auth0EnvConfigs: Auth0EnvConfigs = {
  local: auth0ConfigStaging,
  dev: auth0ConfigStaging,
  test: auth0ConfigTest,
  staging: auth0ConfigStaging,
  regress: auth0ConfigStaging,
  prod: auth0ConfigProd,
};

const reportedMissingBrandConfigs = new Set<string>();

/**
 * The Auth0 client for this environment and the current page's brand.
 * Origin, and pages with no brand, get auth0EnvConfigs[env] unchanged.
 * A brand with no client for this environment also gets Origin's config, so
 * pages still render; the error is logged once because its users cannot log in.
 */
export const getAuth0Config = (
  env: EnvironmentNames,
  brand: string | undefined = getBrand()
): IAuth0Config => {
  if (!brand || brand === ORIGIN_BRAND) return auth0EnvConfigs[env];

  const brandConfig = Object.prototype.hasOwnProperty.call(
    auth0BrandConfigs,
    brand
  )
    ? auth0BrandConfigs[brand][env]
    : undefined;
  if (brandConfig) return brandConfig;

  const missing = `${brand}::${env}`;
  if (!reportedMissingBrandConfigs.has(missing)) {
    reportedMissingBrandConfigs.add(missing);
    logger.error(`${LOG_TAG} No Auth0 config for brand`, { brand, env });
  }
  return auth0EnvConfigs[env];
};
